import React from 'react';
import './Resume.css';

const Resume = ({ decisionData }) => {
    if (!decisionData) return null;

    return (
        <div id="resume" className="content-section">
            {decisionData?.resume ? (
                <p className="content-text">{decisionData?.resume}</p>
            ) : (
                <p className="no-content-text">Aucun résumé disponible pour cette décision.</p>
            )}
        </div>
    );
};

export default Resume;